module.exports = __webpack_public_path__ + "static/26-50504771d1bb1bd9174161c374b18e51.png";